import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TIPO_TRACCIATO_AVP, TipoTracciatoAvp} from "../../../_helpers/TipoTracciatoAvp";

@Component({
    selector: 'app-select-type-tracciato-avp',
    templateUrl: './select-type-tracciato-avp.component.html',
    styleUrls: ['./select-type-tracciato-avp.component.scss'],
    standalone: false
})
export class SelectTypeTracciatoAvpComponent   {
  @Input() tipoTracciatoAvp: TipoTracciatoAvp;
  @Output() tipoTracciatoAvpChange = new EventEmitter<TipoTracciatoAvp>();
  tipoTracciatoAvpItem = TIPO_TRACCIATO_AVP;
  selectTipoTracciatoAvp = (e: SelectCustomEvent) => this.tipoTracciatoAvpChange.emit(+e.target.value);
}
